import { ChangeEvent, FC } from 'react';

import { AvailableCurrencies } from 'utils/clickme';

import FormSpacer from 'bloko/blocks/form/FormSpacer';
import Select, { Option } from 'bloko/blocks/select';

import { setSelectedCurrency } from 'store/models/actsSummary';
import { useDispatch, useSelector } from 'store/utils';

export const SelectActiveCurrency: FC = () => {
    const selectedCurrency = useSelector((state) => state.actsSummary.selectedCurrency);

    const dispatch = useDispatch();

    const onChange = (event: ChangeEvent<HTMLSelectElement>) => {
        dispatch(setSelectedCurrency(event.target.value as AvailableCurrencies));
    };

    return (
        <FormSpacer>
            <Select value={selectedCurrency} onChange={onChange}>
                {Object.entries(AvailableCurrencies).map(([key, value]) => (
                    <Option key={key} value={value}>
                        {value}
                    </Option>
                ))}
            </Select>
        </FormSpacer>
    );
};
